import React, { useState } from 'react';
import { Modal, Form, Input, InputNumber, message } from 'antd';
import api from '../utils/api';

const AddHostelAdminModal = ({ onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      await api.post('/admin/owners', values);
      message.success('Owner created');
      form.resetFields();
      onSuccess();
      onClose();
    } catch (err) {
      if (err.errorFields) return;
      const msg = err.response?.data?.message || err.response?.data?.errors?.[0]?.msg || err.message || 'Error creating owner';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Add Owner"
      open
      onCancel={onClose}
      onOk={handleSubmit}
      confirmLoading={loading}
      destroyOnClose
      okText="Create Owner"
    >
      <Form form={form} layout="vertical">
        <Form.Item name="name" label="Name" rules={[{ required: true }]}>
          <Input placeholder="Name" />
        </Form.Item>
        <Form.Item name="email" label="Email" rules={[{ required: true }, { type: 'email' }]}>
          <Input placeholder="Email" />
        </Form.Item>
        <Form.Item name="password" label="Password" rules={[{ required: true }, { min: 6, message: 'Min 6 characters' }]}>
          <Input.Password placeholder="Password" />
        </Form.Item>
        <Form.Item name="maxHostelsAllowed" label="Maximum Hostels Allowed" initialValue={10} rules={[{ required: true }]} extra="Maximum number of hostels this owner can create">
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddHostelAdminModal;
